import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${componentStyles}`)];
